import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  Flex,
  GridItem,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import MapView from 'components/detailMapData/MapView';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ViewStationData,
  ListStationStatus,
} from 'reactRedux/thunks/stationThunk/stationThunk';
import PageLoader from '../../../components/wholePageLoader/PageLoader';
import PowerBankListDataTable from './PowerBankListDataTable';
import { stationStatus } from 'utils/StaticData';
import { stationStatusColors } from 'utils/StaticData';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { enGB } from 'date-fns/locale';
import * as dateFns from 'date-fns';
import PowerbankOnlineOfflineList from './PowerbankOnlineOfflineList';
import { customStaticRanges } from 'utils/StaticData';
import { FaChevronDown, FaEdit } from 'react-icons/fa';
import { sideBarRoutes } from 'utils/StaticData';
import BackButton from 'components/backButton/BackButton';

const StationDetail = () => {
  const addDays = dateFns.addDays;
  const { stationDetailId } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [showCalendar, setShowCalendar] = useState(false);
  const { adminDetails } = useSelector((state) => state.authSlice);
  const [calendarFilterTitle, setCalendarFilterTitle] = useState('Last 7 days');
  const [tempCalendarFilterTitle, setTempCalendarFilterTitle] =
    useState('Last 7 days');
  const [dateRange, setDateRange] = useState([
    {
      endDate: new Date(),
      startDate: addDays(new Date(), -6),
      key: 'selection',
    },
  ]);
  const getInitialDateRange = () => {
    const endDate = new Date();
    const startDate = addDays(new Date(), -6);
    return {
      startDate: dateFns.format(startDate, 'yyyy/MM/dd'),
      endDate: dateFns.format(endDate, 'yyyy/MM/dd'),
    };
  };
  const [apiDateRange, setApiDateRange] = useState(getInitialDateRange());
  const dispatch = useDispatch();
  const {
    viewStationDetails,
    isViewLoading,
    isLoading,
    powerBankOnlineOfflineList,
  } = useSelector((state) => state.StationSlice);

  useEffect(() => {
    if (stationDetailId) {
      dispatch(ViewStationData({ id: stationDetailId }));
    }
  }, [dispatch, stationDetailId]);

  /////// Powerbnak online offline API calling /////
  const handleSelect = (ranges) => {
    const selectedRange = customStaticRanges.find(
      (range) =>
        range.range().startDate.getTime() ===
          ranges.selection.startDate.getTime() &&
        range.range().endDate.getTime() === ranges.selection.endDate.getTime(),
    );

    setTempCalendarFilterTitle(selectedRange?.label || 'Custom');
    setDateRange([ranges.selection]);
  };

  const handleClear = () => {
    const newRange = {
      endDate: new Date(),
      startDate: addDays(new Date(), -6),
      key: 'selection',
    };
    setDateRange([newRange]);
    setShowCalendar(false);
  };

  const handleApply = () => {
    const startDate = dateFns.format(dateRange[0].startDate, 'yyyy/MM/dd');
    const endDate = dateFns.format(dateRange[0].endDate, 'yyyy/MM/dd');
    setShowCalendar(false);
    setApiDateRange({
      startDate: startDate,
      endDate: endDate,
    });
    setCalendarFilterTitle(tempCalendarFilterTitle);
    setPage(1);
  };

  useEffect(() => {
    dispatch(
      ListStationStatus(stationDetailId, {
        page: page,
        limit: 10,
        start: apiDateRange.startDate,
        end: apiDateRange.endDate,
      }),
    );
  }, [page, dispatch, stationDetailId, apiDateRange]);

  return (
    <>
      {isViewLoading ? (
        <PageLoader />
      ) : (
        <Box pt={{ base: '60px', md: '80px', xl: '80px' }}>
          <Flex justifyContent="space-between" mb={4} gap="3">
            <BackButton
              fallbackUrl="/admin/stations"
              label="Back to Stations"
            />
            <Flex gap="3">
              {adminDetails?.role !== sideBarRoutes?.Merchant && (
                <Button
                  py="10px"
                  px="15px"
                  fontWeight="semibold"
                  borderRadius="8px"
                  bg="primary"
                  color="white"
                  _hover={{ bg: 'primary', opacity: 0.8 }}
                  type="button"
                  leftIcon={<FaEdit size={22} />}
                  onClick={() =>
                    navigate(
                      `/admin/stations/edit/${viewStationDetails?.stationId}`,
                    )
                  }
                >
                  Edit Station
                </Button>
              )}
            </Flex>
          </Flex>
          <Flex direction="column">
            {viewStationDetails ? (
              <>
                <Card
                  w="100%"
                  boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
                  borderRadius="20px"
                  paddingInline="40px"
                  paddingBlock="40px"
                  overflowX={{ sm: 'scroll', lg: 'hidden' }}
                >
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal" width="90px">
                        Station Id :
                      </Text>
                      <Text fontWeight="semibold">
                        {viewStationDetails.stationId}
                      </Text>
                    </Flex>

                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal" flexShrink="0">
                        Slots :
                      </Text>
                      <Text fontWeight="semibold">
                        {viewStationDetails?.slots}
                      </Text>
                    </Flex>

                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal">Status :</Text>
                      <Text
                        fontWeight="semibold"
                        color={
                          stationStatusColors[viewStationDetails?.status] ||
                          'gray.500'
                        }
                      >
                        {stationStatus[viewStationDetails?.status] || 'N/A'}
                      </Text>
                    </Flex>

                    {viewStationDetails?.merchant &&
                      Object.keys(viewStationDetails.merchant).length > 0 && (
                        <>
                          <Flex
                            alignItems={{ sm: 'start', md: 'center' }}
                            direction={{ sm: 'column', md: 'row' }}
                            gap="10px"
                            padding="4px 8px"
                            borderLeft={'1px solid #ccc'}
                          >
                            <Text fontWeight="normal" flexShrink="0">
                              Merchant Id :
                            </Text>
                            <Text fontWeight="semibold">
                              {viewStationDetails?.merchant?.merchantId}
                            </Text>
                          </Flex>

                          <Flex
                            alignItems={{ sm: 'start', md: 'center' }}
                            direction={{ sm: 'column', md: 'row' }}
                            gap="10px"
                            padding="4px 8px"
                            borderLeft={'1px solid #ccc'}
                          >
                            <Text fontWeight="normal" flexShrink="0">
                              Merchant Name :
                            </Text>
                            <Text fontWeight="semibold">
                              {viewStationDetails?.merchant?.name}
                            </Text>
                          </Flex>

                          <Flex
                            alignItems={{ sm: 'start', md: 'center' }}
                            direction={{ sm: 'column', md: 'row' }}
                            gap="10px"
                            padding="4px 8px"
                            borderLeft={'1px solid #ccc'}
                          >
                            <Text fontWeight="normal" flexShrink="0">
                              Label :
                            </Text>
                            <Text fontWeight="semibold">
                              {viewStationDetails?.location}
                            </Text>
                          </Flex>

                          <Flex
                            alignItems={{ sm: 'start', md: 'center' }}
                            direction={{ sm: 'column', md: 'row' }}
                            gap="10px"
                            padding="4px 8px"
                            borderLeft={'1px solid #ccc'}
                          >
                            <Text fontWeight="normal" flexShrink="0">
                              Address :
                            </Text>
                            <Text fontWeight="semibold">
                              {viewStationDetails?.merchant?.address}
                            </Text>
                          </Flex>

                          {viewStationDetails?.coordinates && (
                            <GridItem colSpan={{ base: 1, md: 2 }}>
                              <Text fontWeight="normal" mb={2}>
                                Coordinates :
                              </Text>
                              <MapView
                                coordinates={
                                  viewStationDetails?.coordinates || [0, 0]
                                }
                                isChange={false}
                              />
                            </GridItem>
                          )}
                        </>
                      )}
                  </SimpleGrid>
                </Card>
                {viewStationDetails?.powerbank &&
                  viewStationDetails?.powerbank?.length > 0 && (
                    <>
                      <Box pt="30px" alignItems="left">
                        <Text fontSize="2xl" fontWeight="medium">
                          Powerbanks
                        </Text>
                      </Box>
                      <Card
                        w="100%"
                        boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
                        borderRadius="20px"
                        paddingInline="40px"
                        paddingBlock="40px"
                        overflowX={{ sm: 'scroll', lg: 'hidden' }}
                        mt="20px"
                      >
                        <PowerBankListDataTable
                          tableData={viewStationDetails?.powerbank}
                          isLoading={isViewLoading}
                          stationId={stationDetailId}
                        />
                      </Card>
                    </>
                  )}

                {/* Status History Online offline table with pagination */}
                <Box pt="30px">
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Text fontSize="2xl" fontWeight="medium">
                      Status History
                    </Text>
                    <Text>Data available since May 9, 2025</Text>
                  </Box>
                  <Card
                    w="100%"
                    boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
                    borderRadius="20px"
                    paddingInline="40px"
                    paddingBlock="40px"
                    overflowX={{ sm: 'scroll', lg: 'hidden' }}
                    position={'static'}
                    mt="20px"
                  >
                    {/* Top row with counts and date picker */}
                    <Flex
                      justifyContent={{ sm: 'start', md: 'end' }}
                      alignItems="center"
                      mb="20px"
                      flexWrap="wrap"
                      gap="15px"
                    >
                      <Flex alignItems="center" flexWrap={'wrap'} gap="30px">
                        <Box
                          display={'flex'}
                          alignItems={'center'}
                          gap={'10px'}
                        >
                          <Text fontSize="md" color="gray.500">
                            Online Time(Minutes):
                          </Text>
                          <Text fontSize="md">
                            {powerBankOnlineOfflineList.onlineTime}
                          </Text>
                        </Box>
                        <Box
                          display={'flex'}
                          alignItems={'center'}
                          gap={'10px'}
                        >
                          <Text fontSize="md" color="gray.500">
                            Offline Count:
                          </Text>
                          <Text fontSize="md">
                            {powerBankOnlineOfflineList.offlineCount}
                          </Text>
                        </Box>
                      </Flex>

                      {/* Date range dropdown button */}
                      <Button
                        py="10px"
                        px="15px"
                        fontWeight="semibold"
                        type="button"
                        bg="white"
                        border="1px solid"
                        borderColor="reviveGray"
                        color="#292D32"
                        borderRadius="8px"
                        onClick={() => setShowCalendar(!showCalendar)}
                        justifyContent="space-between"
                        minWidth="200px"
                        rightIcon={<FaChevronDown size={11} />}
                      >
                        {calendarFilterTitle}
                      </Button>
                    </Flex>

                    {/* Date range picker popup */}
                    {showCalendar && (
                      <>
                        <Box
                          position="fixed"
                          bg="rgb(0 0 0 / 40%)"
                          top="0"
                          left="0"
                          right="0"
                          bottom="0"
                          zIndex="9"
                          onClick={() => setShowCalendar(false)}
                        ></Box>
                        <Box
                          p="32px"
                          mt="8px"
                          position="absolute"
                          right="50px"
                          zIndex="10"
                          bg="white"
                          boxShadow="0px 0px 40px rgba(32, 57, 70, 0.06)"
                          borderRadius="20px"
                          className="custom-date-picker only-date-range"
                        >
                          <DateRangePicker
                            ranges={dateRange}
                            onChange={handleSelect}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            direction="horizontal"
                            locale={enGB}
                            minDate={new Date(2000, 0, 1)}
                            maxDate={new Date()}
                            staticRanges={customStaticRanges}
                            inputRanges={[]}
                          />
                          <Flex
                            justifyContent="right"
                            gap="12px"
                            marginTop="30px"
                          >
                            <Button
                              className="clear-btn"
                              border="1px solid"
                              borderColor="reviveGray"
                              borderRadius="10px"
                              onClick={handleClear}
                            >
                              Clear
                            </Button>
                            <Button
                              className="apply-btn"
                              bg="#6658fd"
                              border="1px solid"
                              borderColor="#6658fd"
                              color="white"
                              borderRadius="10px"
                              _hover={{
                                bg: 'transparent',
                                color: '#6658fd',
                              }}
                              onClick={handleApply}
                            >
                              Apply
                            </Button>
                          </Flex>
                        </Box>
                      </>
                    )}

                    {/* Data table */}
                    <PowerbankOnlineOfflineList
                      tableData={powerBankOnlineOfflineList}
                      isLoader={isLoading}
                      page={page}
                      setPage={setPage}
                    />
                  </Card>
                </Box>
              </>
            ) : (
              <Text>No station details found.</Text>
            )}
          </Flex>
        </Box>
      )}
    </>
  );
};

export default StationDetail;
